import React, { useEffect, useState } from 'react';
import { BellRing, BellOff, Lock } from 'lucide-react';
import { Switch } from '../ui/switch';
import { toast } from '../../hooks/use-toast';
import api from '../../services/api';

export const PortalNotificationSounds = ({ isViewer }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/api/settings/portal-notification-sounds').then((r) => setRows(r.data)).catch(() => {}); }, []);

  const toggle = async (key, sound) => {
    const next = Object.fromEntries(rows.map((r) => [r.key, r.key === key ? sound : r.sound]));
    setRows((rs) => rs.map((r) => (r.key === key ? { ...r, sound } : r)));
    try {
      setRows((await api.put('/api/settings/portal-notification-sounds', { sound: next })).data);
    } catch {
      toast({ title: 'Could not save', variant: 'destructive' });
      setRows((rs) => rs.map((r) => (r.key === key ? { ...r, sound: !sound } : r)));
    }
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5 space-y-3" data-testid="portal-notif-sounds-card">
      <div>
        <h3 className="flex items-center gap-2 font-semibold text-gray-900"><BellRing className="h-4 w-4 text-indigo-600" /> Employee Portal notification sounds</h3>
        <p className="text-xs text-gray-500">Choose which notifications play the phone's sound. Silent ones still appear in the notification list and on the app icon count.</p>
      </div>
      <div className="divide-y">
        {rows.map((r) => (
          <div key={r.key} className="flex items-center justify-between py-2" data-testid={`notif-sound-row-${r.key}`}>
            <span className="flex items-center gap-2 text-sm text-gray-800">
              {r.sound ? <BellRing className="h-3.5 w-3.5 text-emerald-600" /> : <BellOff className="h-3.5 w-3.5 text-gray-400" />}
              {r.label}
              {r.locked && <span className="flex items-center gap-0.5 text-[10px] text-gray-400"><Lock className="h-3 w-3" /> always on</span>}
            </span>
            <span className="flex items-center gap-2 text-[11px] text-gray-500">
              {r.sound ? 'Sound' : 'Silent'}
              <Switch checked={r.sound} disabled={r.locked || isViewer} onCheckedChange={(v) => toggle(r.key, v)} data-testid={`notif-sound-toggle-${r.key}`} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
